<template>
    <div>
        <table class="table" v-if="data">
            <thead>
                <tr>
                    <th>Leadtime</th>
                    <th>SL Date</th>
                    <th>Expedition</th>
                    <th>No License</th>
                    <th>Driver</th>
                    <th>Warehouse Destination</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="data.length > 0">
                    <tr v-for="dat in dataShown">
                        <td style="text-decoration: underline;"><b>{{ dat.lead_time ? dat.lead_time : '-' }}</b></td>
                        <td>{{ dat.sl_date ? moment(dat.sl_date).format("DD MMM YYYY HH:mm:ss") : '-' }}</td>
                        <td>{{ dat.ekspedisi ? dat.ekspedisi : '-' }}</td>
                        <td>{{ dat.nopol ? dat.nopol : '-' }}</td>
                        <td>{{ dat.sopir ? dat.sopir : '-' }}</td>
                        <td>{{ dat.destination ? dat.destination : '-' }}</td>
                    </tr>
                    <tr v-if="showAllButton">
                        <td v-if="!showAll" colspan="9" class="moreButton" @click="showAll = true">Lihat Semua</td>
                        <td v-else colspan="9" class="moreButton" @click="showAll = false">Sembunyikan</td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td colspan="100%" class="text-center">No Data</td>
                    </tr>
                </template>
            </tbody>
        </table>
        <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                moment: moment,
                showAllButton: true,
                showAll: false,
                // ready: false,
                // dummyData: null,
            }
        },
        props: ['data'],
        mounted() {
            // this.generateDummyData();
        },
        computed : {
            dataShown () {
                // return this.showAll ? this.dummyData : this.dummyData.slice(0, 6);
                return this.showAll ? this.data : this.data.slice(0, 6);
            },
        },
        methods: {
            generateDummyData () {
                let data = [];

                let counter = 0;
                let expeditions = [
                    'TRIT - PT. TRISTART TRANSINDO',
                    'RTJM - PT. RODA JAYA TUNAS MAS',
                    'TRJA - PT. TRIO JAYA ANUGRAH',
                    'CAMB - CIPTA ANUGERAH MAJU BERSAMA',
                    'RUJK - PT. RUKUN JAYA KOMPAK'
                ]
                let licenses = [
                    'B 9634 PEH',
                    'B 9065 SYO',
                    'B 9763 UYT',
                    'B 9176 UWV'
                ]
                let drivers = [
                    'Edi',
                    'Bejo',
                    'Agus',
                    'Septian',
                    'Edizal',
                    'Suhanto'
                ]
                let gudang = this.$store.getters.getGudang().map(x=>x.code)
                for (var i = 19; i > 0; i--) {
                    counter++;

                    data.push({
                        leadtime : i,
                        sl_date : `${counter+10} Aug 21`,
                        expedition : expeditions[this.randomInt(0, expeditions.length)],
                        no_license : licenses[this.randomInt(0, licenses.length)],
                        driver : drivers[this.randomInt(0, drivers.length)],
                        destination : gudang[this.randomInt(0, gudang.length)]
                    })
                }

                this.dummyData = data;
                this.ready = true;
            },
        }
    }
</script>

<style scoped>
    table tr th,
    table tr td {
        text-align: center;
        vertical-align: middle;
    }

    table tr th {
        border-bottom: 1px solid #F75047;
    }
</style>